import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

// After a hard check-in, suggest shaking the gratitude jar
export const GratitudeNudge = () => {
  const [n, setN] = useState(null);
  useEffect(() => { api.get("/gratitude/nudge").then((r) => setN(r.data)).catch((e) => logError("Gratitude nudge failed:", e)); }, []);
  if (!n?.show) return null;
  const hide = () => { setN(null); api.post("/gratitude/nudge/dismiss").catch(() => {}); };
  return (
    <div className="mb-6 rounded-3xl bg-[#FFF6D6] p-5 flex items-center gap-4 mm-fade-up" data-testid="home-gratitude-nudge">
      <div className="text-4xl" aria-hidden>🫙</div>
      <div className="flex-1 text-[#3A2E4F]">
        <div className="font-semibold">Shake your gratitude jar</div>
        <div className="text-sm opacity-75">Hard days happen. There are {n.count} good moment{n.count === 1 ? "" : "s"} waiting in your jar.</div>
      </div>
      <Link to="/gratitude" className="mm-btn !py-2 !px-4 text-sm shrink-0" data-testid="home-gratitude-open">Open</Link>
      <button onClick={hide} className="p-1 text-[#3A2E4F]/50" aria-label="Not now" data-testid="home-gratitude-dismiss"><X size={16} /></button>
    </div>
  );
};
